import React, { useEffect, useState } from "react";
import SelectComponent from "../../../components/Tenant/SelectComponent/SelectComponent";
import InputComponent from "../../../components/Tenant/InputComponent/InputComponent";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { toast } from "react-hot-toast";
import {
  useAddPGCredentialsMutation,
  useFetchPGCredentialsQuery,
} from "../../../features/tenant/payoutGatewayCredentials/payoutGatewayCredentialsApi";
import { useNavigate } from "react-router-dom";
import { useCreateSkuProductMapMutation, useFetchCenturyCategoryMutation, useFetchCenturyProductMutation, useFetchCenturySubCategoryMutation, useAddCenturySubCategoryMutation, useAddCenturyProductMutation } from "../../../features/tenant/skuProductMap/skuProductMapApi";

const AddSkuProductMap = () => {
  const navigate = useNavigate();
  const [
    fetchMasterCategory,
    {
      data: centuryMasterCategoryData,
      isLoading: fetchMasterCategoryIsLoading,
      isError: fetchMasterCategoryIsError,
      error: fetchMasterCategoryError,
    },
  ] = useFetchCenturyCategoryMutation();

  const [
    fetchSubCategory,
    {
      data: centurySubCategoryData,
      isLoading: fetchSubCategoryIsLoading,
      isError: fetchSubCategoryIsError,
      error: fetchSubCategoryError,
    },
  ] = useFetchCenturySubCategoryMutation();

  const [
    fetchProduct,
    {
      data: centuryProductData,
      isLoading: fetchProductIsLoading,
      isError: fetchProductIsError,
      error: fetchProductError,
    },
  ] = useFetchCenturyProductMutation();

  const [
    createProductMap,
    {
      data: createProductMapData,
      isLoading: createProductMapIsLoading,
      isError: createProductMapIsError,
      error: createProductMapError,
    },
  ] = useCreateSkuProductMapMutation();

  const [
    addSubCategory,
    {
      data: addSubCategoryData,
      isLoading: addSubCategoryIsLoading,
      isError: addSubCategoryIsError,
      error: addSubCategoryError,
    },
  ] = useAddCenturySubCategoryMutation();

  const [
    addProduct,
    {
      data: addProductData,
      isLoading: addProductIsLoading,
      isError: addProductIsError,
      error: addProductError,
    },
  ] = useAddCenturyProductMutation();

  const [category, setCategory] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState({
    id: -1,
    name: "Select Category",
  });

  const [subCategory, setSubCategory] = useState([]);
  const [selectedSubCategory, setSelectedSubCategory] = useState({
    id: -1,
    name: "Select Thickness",
  });

  const [product, setProduct] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState({
    id: -1,
    name: "Select Size",
  });

  const [skuCode, setSkuCode] = useState("");

  const [selectedPGType, setselectedPGType] = useState({
    id: -1,
    name: "select Payment Gateway",
  });

  const [inputClientId, setInputClientId] = useState(null);
  const [inputClientSecret, setInputClientSecret] = useState(null);
  const [inputHatioWalletId, setInputHatioWalletId] = useState(null);

  // States for adding dynamic Thickness
  const [showThicknessModal, setShowThicknessModal] = useState(false);
  const [newThicknessName, setNewThicknessName] = useState("");
  const [pendingThickness, setPendingThickness] = useState(null);

  // States for adding dynamic Size
  const [showSizeModal, setShowSizeModal] = useState(false);
  const [newSizeName, setNewSizeName] = useState("");
  const [newProductCode, setNewProductCode] = useState("");
  const [pendingSize, setPendingSize] = useState(null);
  const [loyaltyPoints, setLoyaltyPoints] = useState("");
  const [mainPoints, setMainPoints] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault()

    if (selectedProduct.id === -1 || skuCode.trim() === "") {
      toast.dismiss();
      toast.error("Please select Size and enter SKU Code", {
        id: "invalid-missing-field",
      });
      return;
    }

    createProductMap({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: {
        sku_code: skuCode,
        product_code: selectedProduct.product_code,
        loyalty_points: Number(mainPoints) || 0,
      }
    })
    console.log("selectedProduct", selectedProduct);
  }
  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   if (
  //     selectedPGType.id == "" ||
  //     selectedPGType == "select Payment Gateway" ||
  //     inputClientSecret == null ||
  //     inputClientSecret == "" ||
  //     inputClientId == null ||
  //     inputClientId == ""
  //   ) {
  //     toast.dismiss();
  //     toast.error("Invalid or missing field", {
  //       id: "invalid-missing-field",
  //     });
  //     return;
  //   }

  //   if( selectedPGType.name == "hatio" && !inputHatioWalletId){
  //     toast.dismiss();
  //     toast.error("Please enter Wallet ID", {
  //       id: "invalid-missing-field",
  //     });
  //     return;
  //   }

  //   addPGCredentials({
  //     token: sessionStorage.getItem("access_token"),
  //     tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
  //     body: {
  //       type: selectedPGType.name,
  //       client_id: inputClientId,
  //       client_secret: inputClientSecret,
  //       wallet_id : inputHatioWalletId 
  //     },
  //   });
  // };

  useEffect(() => {
    fetchMasterCategory({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
    })
  }, [])
  useEffect(() => {
    if (centuryMasterCategoryData && fetchMasterCategoryIsError == false) {
      toast.dismiss();
      setCategory(centuryMasterCategoryData.body)
      setSelectedCategory({
        id: -1,
        name: "Select Category",
      });
    }



    if (fetchMasterCategoryIsError) {
      toast.dismiss();
      console.log("fetchMasterCategoryError", fetchMasterCategoryError);
      toast.error(fetchMasterCategoryError.data.message, {
        id: "fetchMasterCategoryIsError",
      });
    }

  }, [centuryMasterCategoryData, fetchMasterCategoryIsError]);

  useEffect(() => {
    console.log("selectedCategory", selectedCategory);
    if (selectedCategory.id != -1) {
      fetchSubCategory({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        id: selectedCategory.id,
      });
    }
  }, [selectedCategory])

  useEffect(() => {
    if (centurySubCategoryData && fetchSubCategoryIsError == false) {
      toast.dismiss();
      setSubCategory(centurySubCategoryData.body);
      if (pendingThickness) {
        setSelectedSubCategory(pendingThickness);
        setPendingThickness(null);
      } else {
        setSelectedSubCategory({
          id: -1,
          name: "Select Thickness",
        });
        setSelectedProduct({
          id: -1,
          name: "Select Size",
        });
      }
    }

    if (fetchSubCategoryIsError) {
      toast.dismiss();
      console.log("fetchSubCategoryError", fetchSubCategoryError);
      toast.error(fetchSubCategoryError.data.message, {
        id: "fetchSubCategoryIsError",
      });
    }

  }, [centurySubCategoryData, fetchSubCategoryIsError]);


  useEffect(() => {
    if (selectedSubCategory.id !== -1) {
      fetchProduct({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        id: selectedSubCategory.id,
      });
    }
  }, [selectedSubCategory])

  useEffect(() => {
    if (centuryProductData && fetchProductIsError == false) {
      toast.dismiss();
      console.log("centuryProductData", centuryProductData);
      let prodData = centuryProductData.body.data.map((item) => {
        const pts = item.retailer_points ?? item.oem_points ?? 0;
        return {
          id: item.product_id,
          name: item.size,
          product_code: item.product_code,
          points: Number(pts),
        };
      });
      setProduct(prodData);
      console.log("product", prodData);
      if (pendingSize) {
        setSelectedProduct(pendingSize);
        setPendingSize(null);
      } else {
        setSelectedProduct({
          id: -1,
          name: "Select Size",
        });
      }
    }

    if (fetchProductIsError) {
      toast.dismiss();
      console.log("fetchProductError", fetchProductError);
      toast.error(fetchProductError.data.message, {
        id: "fetchProductIsError",
      });
    }

  }, [centuryProductData, fetchProductIsError]);

  useEffect(() => {
    if (selectedProduct && selectedProduct.id !== -1) {
      const matchedProd = product.find((p) => p.id === selectedProduct.id);
      if (matchedProd && matchedProd.points !== undefined) {
        setMainPoints(String(matchedProd.points));
      }
    } else {
      setMainPoints("");
    }
  }, [selectedProduct, product]);


  useEffect(() => {

    if (createProductMapData && createProductMapIsError == false) {
      toast.dismiss();
      toast.success("SKU Product Mapping created successfully", {
        id: "createProductMapSuccess",
      });
      navigate(-1);
    }

    if (createProductMapError) {
      toast.dismiss();
      console.log("createProductMapError", createProductMapError);
      toast.error(createProductMapError.data.message, {
        id: "createProductMapIsError",
      });
    }

  }, [createProductMapData, createProductMapError]);

  // Handle Thickness creation response
  useEffect(() => {
    if (addSubCategoryData && addSubCategoryIsError === false) {
      toast.dismiss();
      toast.success("Thickness added successfully", { id: "addThicknessSuccess" });
      setShowThicknessModal(false);
      const newCat = addSubCategoryData.body || addSubCategoryData.data;
      if (newCat) {
        setPendingThickness({ id: newCat.id, name: newCat.name });
      }
      setNewThicknessName("");
      fetchSubCategory({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        id: selectedCategory.id,
      });
    }
    if (addSubCategoryIsError) {
      toast.dismiss();
      toast.error(addSubCategoryError?.data?.message || "Failed to add thickness", {
        id: "addThicknessError",
      });
    }
  }, [addSubCategoryData, addSubCategoryIsError]);

  // Handle Size creation response
  useEffect(() => {
    if (addProductData && addProductIsError === false) {
      toast.dismiss();
      toast.success("Size added successfully", { id: "addSizeSuccess" });
      setShowSizeModal(false);
      const createdProd = addProductData.body || addProductData.data;
      if (createdProd) {
        setPendingSize({
          id: createdProd.product_id || createdProd.id,
          name: createdProd.size || createdProd.name,
          product_code: createdProd.product_code,
        });
      }
      setNewSizeName("");
      fetchProduct({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        id: selectedSubCategory.id,
      });
    }
    if (addProductIsError) {
      toast.dismiss();
      toast.error(addProductError?.data?.message || "Failed to add size", {
        id: "addSizeError",
      });
    }
  }, [addProductData, addProductIsError]);

  const handleOpenAddThickness = () => {
    if (selectedCategory.id === -1) {
      toast.dismiss();
      toast.error("Please select a Category first", { id: "selectCategoryFirst" });
      return;
    }
    setNewThicknessName("");
    setShowThicknessModal(true);
  };

  const handleSaveThickness = (e) => {
    e.preventDefault();
    if (!newThicknessName.trim()) {
      toast.dismiss();
      toast.error("Please enter a Thickness name");
      return;
    }
    const isDup = subCategory.some(
      (item) => item.name && item.name.trim().toLowerCase() === newThicknessName.trim().toLowerCase()
    );
    if (isDup) {
      toast.dismiss();
      toast.error("Thickness already exists in this category");
      return;
    }
    addSubCategory({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: {
        name: newThicknessName.trim(),
        is_sub: 1,
        master_id: selectedCategory.id,
        is_master: 0,
      },
    });
  };

  const handleOpenAddSize = () => {
    if (selectedSubCategory.id === -1) {
      toast.dismiss();
      toast.error("Please select a Thickness first", { id: "selectThicknessFirst" });
      return;
    }
    setNewSizeName("");
    setNewProductCode("");
    setLoyaltyPoints("");
    setShowSizeModal(true);
  };

  const handleSaveSize = (e) => {
    e.preventDefault();
    if (!newSizeName.trim()) {
      toast.dismiss();
      toast.error("Please enter a Size name");
      return;
    }
    const isDupSize = product.some(
      (p) => p.name && p.name.trim().toLowerCase() === newSizeName.trim().toLowerCase()
    );
    if (isDupSize) {
      toast.dismiss();
      toast.error("Size already exists in this thickness");
      return;
    }
    const sizeRegex = /^\d+(\.\d+)?\s*[Xx]\s*\d+(\.\d+)?$/;
    if (!sizeRegex.test(newSizeName.trim())) {
      toast.dismiss();
      toast.error("Please use format: WidthXHeight (e.g. 8X4 or 7X3)");
      return;
    }
    const autoProductCode = `${selectedCategory.name}-${selectedSubCategory.name}-${newSizeName.trim()}`;
    addProduct({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: {
        name: autoProductCode,
        description: autoProductCode,
        qr_type: "1",
        product_code: autoProductCode,
        image: "https://dummyimage.com/100x100",
        status: "1",
        unit_name: "Pieces",
        unit_id: 3,
        brand_id: 1,
        brand_name: "Century",
        category_id: selectedSubCategory.id,
        category_name: selectedSubCategory.name,
        classification: selectedSubCategory.name,
        size: newSizeName.trim(),
        qty: 1000,
        mrp: 0,
        oem_points: Number(loyaltyPoints) || 0,
        retailer_points: Number(loyaltyPoints) || 0,
        stockist_points: Number(loyaltyPoints) || 0,
        substockist_points: Number(loyaltyPoints) || 0,
        facilitator_points: Number(loyaltyPoints) || 0,
        loyalty_points: Number(loyaltyPoints) || 0,
      },
    });
  };



  return (
    <>
      <div className="flex w-full bg-gray-200 h-full justify-center">
        <div className="w-full ">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            {/* { isUpdate ? "Update" : "Add" } Batch */}
            Add SKU Product Mapping
            <LinksComponent />
          </div>
          <div className="p-3">
            <form className="bg-white shadow rounded-lg p-3">
              <div className="w-full  flex justify-center space-x-3">
                {/* <h2 className="font-bold text-xl mb-3">Add Batch</h2> */}

                <div className="mb-6 w-1/3 dropds">
                  <InputComponent
                    name={"SKU Code"}
                    type={"text"}
                    value={skuCode}
                    setValue={setSkuCode}
                    required={true}
                  />
                </div>

                <div className="mb-6 w-1/3 dropds">
                  <SelectComponent
                    title={"Category"}
                    selected={selectedCategory}
                    setSelected={setSelectedCategory}
                    dataArr={category}
                  />
                </div>

                <div className="mb-6 w-1/3 dropds">
                  <SelectComponent
                    title={"Thickness"}
                    selected={selectedSubCategory}
                    setSelected={setSelectedSubCategory}
                    dataArr={subCategory}
                    onAddNew={handleOpenAddThickness}
                    addLabel={"Add"}
                  />
                </div>

                <div className="mb-6 w-1/3 dropds">
                  <SelectComponent
                    title={"Size"}
                    selected={selectedProduct}
                    setSelected={setSelectedProduct}
                    dataArr={product}
                    onAddNew={handleOpenAddSize}
                    addLabel={"Add"}
                  />
                </div>

                <div className="mb-6 w-1/3 dropds">
                  <InputComponent
                    name={"Loyalty Points"}
                    type={"number"}
                    value={mainPoints}
                    setValue={setMainPoints}
                    required={true}
                  />
                </div>

              </div>
              <div className="flex justify-center mt-2">
                <button
                  type="submit"
                  onClick={(e) => handleSubmit(e)}
                  className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                >
                  Add
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Add Thickness Modal */}
      {showThicknessModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg p-6 w-96 shadow-xl">
            <h3 className="text-lg font-bold mb-4 text-gray-800">Add New Thickness</h3>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Category: <span className="font-semibold text-blue-600">{selectedCategory.name}</span>
              </label>
              <input
                type="text"
                placeholder="Enter thickness (e.g. 18mm)"
                value={newThicknessName}
                onChange={(e) => setNewThicknessName(e.target.value)}
                className="w-full border border-gray-300 rounded-lg p-2.5 text-sm focus:ring-blue-500 focus:border-blue-500"
                autoFocus
              />
            </div>
            <div className="flex justify-end space-x-3">
              <button
                type="button"
                onClick={() => setShowThicknessModal(false)}
                className="px-4 py-2 text-sm font-medium text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleSaveThickness}
                disabled={addSubCategoryIsLoading}
                className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg disabled:opacity-50"
              >
                {addSubCategoryIsLoading ? "Saving..." : "Save Thickness"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add Size Modal */}
      {showSizeModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg p-6 w-96 shadow-xl">
            <h3 className="text-lg font-bold mb-4 text-gray-800">Add New Size</h3>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Thickness: <span className="font-semibold text-blue-600">{selectedSubCategory.name}</span>
              </label>
              <div className="mb-3">
                <label className="block text-xs text-gray-500 mb-1">Size Name *</label>
                <input
                  type="text"
                  placeholder="Enter size (e.g. 7X6 or 8x4)"
                  value={newSizeName}
                  onChange={(e) => setNewSizeName(e.target.value)}
                  className="w-full border border-gray-300 rounded-lg p-2.5 text-sm focus:ring-blue-500 focus:border-blue-500"
                  autoFocus
                />
              </div>

            </div>
            <div className="flex justify-end space-x-3">
              <button
                type="button"
                onClick={() => setShowSizeModal(false)}
                className="px-4 py-2 text-sm font-medium text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleSaveSize}
                disabled={addProductIsLoading}
                className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg disabled:opacity-50"
              >
                {addProductIsLoading ? "Saving..." : "Save Size"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddSkuProductMap;
